// Core
import React from 'react'

// Library
import clsx from 'clsx'

// Styles
import classes from 'components/Onboarding/Disclaimer/Disclaimer.module.scss'

// Assets
import { ReactComponent as LockIcon } from 'assets/icons/icon_lock.svg'

export default function CardDisclaimer() {
  return (
    <div className={clsx(classes.container)}>
      <LockIcon />
      <span className={clsx(classes.label)}>
        No credit card required. Free 30 day trial
      </span>
    </div>
  )
}
